var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"slide-modal-title"},[_vm._v("Edit bike")]),_vm._v(" "),_c('AddEditBike',{attrs:{"bike":_vm.bike,"button-text":"Save Bike","hide-is-ebike-radio":true},on:{"submit-bike":_vm.edit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }